export const DOCUMENT_NAME_KEY = 'documentName';

export const UPLOAD_DATE_KEY = 'uploadDate';
